/**
 * FRIDGE-1072 / FRIDGE-1073 — the approved hero cutouts.
 *
 * The homepage hero used to render whatever photograph the catalog held for a
 * FIN, and only three FINs had a curated cutout. On 09/17/2026 the owner saw a
 * retailer marketing banner burned into the FIN-0000108 slide ("some red
 * banner on product … way too much padding") and an off-centre FIN-0000110
 * slide. Catalog photography is a retailer asset: it carries banners,
 * lifestyle backgrounds and asymmetric whitespace, and `object-fit: contain`
 * preserves all of it.
 *
 * THE RULE: a FIN with no entry here cannot be selected into the hero or the
 * Price Intelligence rotator (lib/homepage-2026/hero-selection.ts), and a
 * homepage product card whose FIN has an entry shows the vetted cutout instead
 * of the catalog lead image. Every file is a tight, centred, banner-free
 * product cutout under public/homepage-2026/canvas/ — trimmed to the subject
 * with a 3% white margin — and the guard test checks each file exists.
 *
 * Adding a hero FIN to HERO_FINS (lib/homepage-2026/links.ts) therefore means
 * vetting its photo and adding it here; the selection test fails otherwise.
 */
export const HERO_IMAGES: Readonly<Record<string, string>> = {
  // HERO_FINS
  'FIN-0003863': '/homepage-2026/canvas/fridge-com-koolmore-km-bir2d-pr-hero.jpg',
  'FIN-0000110': '/homepage-2026/canvas/fridge-com-lg-srfb27w3-hero.jpg',
  'FIN-0000108': '/homepage-2026/canvas/fridge-com-lg-lrflc2706s-hero.jpg',
  'FIN-0000161': '/homepage-2026/canvas/fridge-com-ge-fuf17smrww-hero.jpg',
  'FIN-0000068': '/homepage-2026/canvas/fridge-com-lg-lmxs28626s-hero.jpg',
  'FIN-0000082': '/homepage-2026/canvas/fridge-com-lg-lf30s8210s-1.jpg',
  'FIN-0002740': '/homepage-2026/canvas/fridge-com-bosch-b36cl80sns-hero.jpg',
  // FRIDGE-1166: existing mirrored ASI2575GRS front view, visually verified
  // as a centered full appliance with no retailer banner; original bytes retained.
  'FIN-0000107': '/homepage-2026/canvas/fridge-com-amana-asi2575grs-hero.jpg',
  // curated before this registry existed (canvas v55)
  'FIN-0000213': '/homepage-2026/canvas/fridge-com-samsung-rf23bb860012aa-1.jpg',
  'FIN-0016877': '/homepage-2026/canvas/fridge-com-lg-lryxc2606d-1.jpg',
}

/** The approved cutout for a FIN, or null when none has been vetted. */
export function heroImageFor(fin: string): string | null {
  return HERO_IMAGES[fin] ?? null
}
